import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import headerImg from '../../assets/imageforabout/quantum-shield-header.jpg';

const QuantomeHeader = () => {
  useEffect(() => {
    AOS.init({ duration: 800 });
    window.scrollTo(0, 0);
  }, []);

  return (
    <section style={S.hero} className="qhero">
      {/* background grid pattern */}
      <div style={S.grid} />

      <div style={S.inner} className="qhero-inner">

        {/* LEFT — text content */}
        <div style={S.textCol} data-aos="fade-right">

          <h1 style={S.h1}>
            Is Your Domain{' '}
            <span style={S.highlight}>Quantum-Safe?</span>
          </h1>

          <p style={S.sub}>
            Instantly check if your website's certificate can withstand
            quantum computing attacks. Free, no sign-up required.
          </p>

          {/* value-prop row */}
          <div style={S.valueRow}>
            {[
              { icon: 'fa-check-circle', label: 'Free',     sub: 'No signup required'     },
              { icon: 'fa-bolt',         label: 'Instant',  sub: 'Results in seconds'      },
              { icon: 'fa-shield',       label: 'Accurate', sub: 'OpenSSL-based detection' },
            ].map((b, i) => (
              <React.Fragment key={b.label}>
                {i > 0 && <span style={S.divider} />}
                <div style={S.valueItem}>
                  <i className={`fa ${b.icon}`} style={S.valueIcon} />
                  <div style={S.valueLabel}>{b.label}</div>
                  <div style={S.valueSub}>{b.sub}</div>
                </div>
              </React.Fragment>
            ))}
          </div>
        </div>

        {/* RIGHT — image */}
        <div style={S.imgCol} data-aos="fade-left">
          <img
            src={headerImg}
            alt="Quantum Computing"
            style={S.img}
          />
        </div>

      </div>

      {/* bottom fade */}
      <div style={S.fade} />
    </section>
  );
};

const S = {
  hero: {
    position: 'relative',
    background: 'linear-gradient(160deg,#0f1f6e 0%,#1e3a8a 45%,#1e40af 100%)',
    padding: '100px 60px 90px',
    overflow: 'hidden',
  },
  grid: {
    position: 'absolute', inset: 0,
    backgroundImage:
      'linear-gradient(rgba(255,255,255,0.04) 1px,transparent 1px),' +
      'linear-gradient(90deg,rgba(255,255,255,0.04) 1px,transparent 1px)',
    backgroundSize: '40px 40px',
    pointerEvents: 'none',
  },
  inner: {
    position: 'relative', zIndex: 1,
    maxWidth: 1100, margin: '0 auto',
    display: 'flex', alignItems: 'center',
    gap: 60, flexWrap: 'wrap',
  },
  textCol: {
    flex: '1 1 420px',
    minWidth: 0,
    textAlign: 'center',
  },
  imgCol: {
    flex: '1 1 380px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  img: {
    width: '100%',
    maxWidth: 480,
    borderRadius: 20,
    boxShadow: '0 8px 48px rgba(0,0,0,0.4)',
    display: 'block',
  },
  h1: {
    color: '#fff', fontSize: 'clamp(28px,4vw,50px)',
    fontWeight: 800, lineHeight: 1.15,
    margin: '0 0 20px', letterSpacing: -1,
  },
  highlight: {
    background: 'linear-gradient(90deg,#60a5fa,#a78bfa)',
    WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
  },
  sub: {
    color: '#bfdbfe', fontSize: 17, lineHeight: 1.7,
    margin: '0 auto 36px', maxWidth: 480,
  },
  valueRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 0,
    background: 'rgba(255,255,255,0.08)',
    border: '1px solid rgba(255,255,255,0.15)',
    borderRadius: 16,
    padding: '16px 0',
    maxWidth: 420,
    margin: '0 auto',
  },
  valueItem: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 4,
    padding: '0 8px',
  },
  valueIcon: {
    fontSize: 20,
    color: '#60a5fa',
    marginBottom: 2,
  },
  valueLabel: {
    color: '#fff',
    fontWeight: 700,
    fontSize: 15,
    lineHeight: 1.2,
  },
  valueSub: {
    color: '#93c5fd',
    fontSize: 12,
    lineHeight: 1.3,
  },
  divider: {
    width: 1,
    alignSelf: 'stretch',
    background: 'rgba(255,255,255,0.2)',
    flexShrink: 0,
  },
  fade: {
    position: 'absolute', bottom: 0, left: 0, right: 0,
    height: 60,
    background: 'linear-gradient(to bottom,transparent,#f8fafc)',
    pointerEvents: 'none',
  },
};

export default QuantomeHeader;
